export function element(tag, attributes = {}, children = []) {
  const node = document.createElement(tag);
  Object.entries(attributes).forEach(([name, value]) => {
    if (name === 'className') node.className = value;
    else if (name === 'text') node.textContent = String(value ?? '');
    else if (name.startsWith('on') && typeof value === 'function') {
      node.addEventListener(name.slice(2).toLowerCase(), value);
    } else if (value != null && value !== false) {
      node.setAttribute(name, value === true ? '' : String(value));
    }
  });
  const values = Array.isArray(children) ? children : [children];
  values.flat(Infinity).forEach((child) => {
    if (child == null || child === false) return;
    node.appendChild(child instanceof Node ? child : document.createTextNode(String(child)));
  });
  return node;
}

export function replaceChildren(root, children = []) {
  root.replaceChildren(...(Array.isArray(children) ? children : [children]).filter(Boolean));
}
